/* @flow */
import * as React from 'react';
import cx from 'classnames';
import { NavItem } from 'components/NavItem';
import EventTracking from 'lib/EventTracking';

import CurrentUser from 'auth/CurrentUser';
import SETTINGS_ROUTES from 'settings/constants/SettingsRouteConstants';

import './styles/SettingsNav.scss';

type Props = {
  className?: ?string,
  canOwnGroups: boolean,
};

class SettingsNav extends React.Component<Props> {
  renderNotificationPreferencesNavItem() {
    return (
      <NavItem key="NotificationSettings" to={SETTINGS_ROUTES.NOTIFICATIONS}>
        Notification preferences
      </NavItem>
    );
  }

  renderBlockedUsersItem() {
    return (
      <NavItem key="PrivacySettings" to={SETTINGS_ROUTES.BLOCKED_USERS}>
        Blocked users
      </NavItem>
    );
  }

  renderMessageHistoryItem() {
    return (
      <NavItem key="PrintSettings" to={SETTINGS_ROUTES.MESSAGE_HISTORY}>
        Message history
      </NavItem>
    );
  }

  renderUserProfileNavItem() {
    return (
      <NavItem key="UserProfile" to={SETTINGS_ROUTES.PROFILE}>
        Profile
      </NavItem>
    );
  }

  renderWidgetNavItem() {
    return (
      <NavItem key="WidgetSettings" to={SETTINGS_ROUTES.WIDGETS}>
        Widgets
      </NavItem>
    );
  }

  renderArchivedClassesNavItem() {
    return (
      <NavItem key="OrganizeClassesSettings" to={SETTINGS_ROUTES.ARCHIVED_CLASSES}>
        Archived classes
      </NavItem>
    );
  }

  handleConnectedAccountsClicked() {
    EventTracking.trackKey('account_linking.account_settings.connected_accounts.click');
  }

  renderLinkedAccountsNavItem() {
    return (
      <NavItem
        key="LinkedAcccounts"
        to={SETTINGS_ROUTES.APP_INTEGRATIONS}
        onClick={this.handleConnectedAccountsClicked}>
        App integrations
      </NavItem>
    );
  }

  renderIndividualPlanNavItem() {
    const user = CurrentUser.isSignedIn() ? CurrentUser.getUser() : null;
    return user &&
      (user.get('has_active_individual_plan') ||
        user.getPermissions().can_purchase_individual_plan) ? (
      <NavItem key="IndividualPlan" to={SETTINGS_ROUTES.INDIVIDUAL_PLAN}>
        Remind Plan
      </NavItem>
    ) : null;
  }

  render() {
    return (
      <div className={cx('SettingsNav', this.props.className)}>
        <ul>
          {this.renderUserProfileNavItem()}
          {this.renderIndividualPlanNavItem()}
          {this.renderNotificationPreferencesNavItem()}
          {this.renderLinkedAccountsNavItem()}
          {this.props.canOwnGroups && this.renderWidgetNavItem()}
          {this.props.canOwnGroups && this.renderMessageHistoryItem()}
          {this.props.canOwnGroups && this.renderArchivedClassesNavItem()}
          {this.renderBlockedUsersItem()}
        </ul>
      </div>
    );
  }
}

export default SettingsNav;
